export const WATCH_PATH_SEPARATOR = ' > ';

// Men and Women share the same full watch subcategory list.
const ADULT_WATCH_SUBCATEGORIES = [
  'Smartwatches',
  'Analog Watches',
  'Digital Watches',
  'Hybrid Watches',
  'Sports & Outdoor Watches',
  'Dress Watches',
  'Casual Watches',
  'Diving Watches',
  'Pilot & Aviation Watches',
  'Racing & Motorsport Watches',
  'Military & Tactical Watches',
  'Pocket Watches',
  'Vintage & Antique Watches',
  "Kids' Watches",
  'Watch Accessories',
  'Watch Parts & Tools',
];

const KIDS_WATCH_SUBCATEGORIES = [
  'Analog Watches',
  'Digital Watches',
  'Smartwatches',
  'Learning Watches',
  'Sports Watches',
];

export const WATCHES_CATEGORY_TREE = {
  Men: ADULT_WATCH_SUBCATEGORIES,
  Women: ADULT_WATCH_SUBCATEGORIES,
  Kids: KIDS_WATCH_SUBCATEGORIES,
};

export const WATCH_DEPARTMENTS = Object.keys(WATCHES_CATEGORY_TREE);

export function isWatchesListingCategory(category) {
  return category === 'Watches';
}

export function joinWatchSubcategoryPath(parts) {
  return parts.filter(Boolean).join(WATCH_PATH_SEPARATOR);
}

export function parseWatchSubcategoryPath(value) {
  if (!value) {
    return { department: '', subcategory: '' };
  }
  const [department = '', subcategory = ''] = String(value).split(WATCH_PATH_SEPARATOR);
  return { department, subcategory };
}

export function getWatchSubcategories(department) {
  return WATCHES_CATEGORY_TREE[department] || [];
}

export function getWatchDepartmentsForBrowse() {
  return WATCH_DEPARTMENTS;
}
